module.exports = __webpack_public_path__ + "img/IMG-20200120-WA0045.f1bba163.jpg";